import TextArea from './TextArea';

export { TextAreaSize } from './TextArea';
export default TextArea;
